import { render } from "./AnnounceView.vue?vue&type=template&id=667e563b&scoped=true"
import script from "./AnnounceView.vue?vue&type=script&lang=js"
export * from "./AnnounceView.vue?vue&type=script&lang=js"

import "./AnnounceView.vue?vue&type=style&index=0&id=667e563b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667e563b"]])

export default __exports__